export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      Result: 'success',
      LayoutMastaInfo: [
        {
          LayoutMastaId: 5,
          LayoutName: 'hoam系お知らせ一覧画面',
          Device: 1,
          ServiceType: 1,
          Direction: 1,
          Status: 0
        },
        {
          LayoutMastaId: 4,
          LayoutName: 'hoam系ホーム画面',
          Device: 1,
          ServiceType: 1,
          Direction: 1,
          Status: 1
        },
        {
          LayoutMastaId: 3,
          LayoutName: 'コミュニティサポート系ライブカメラ画面',
          Device: 1,
          ServiceType: 1,
          Direction: 1,
          Status: 1
        },
        {
          LayoutMastaId: 2,
          LayoutName: 'コミュニティサポート系お知らせ一覧画面',
          Device: 1,
          ServiceType: 1,
          Direction: 1,
          Status: 1
        },
        {
          LayoutMastaId: 1,
          LayoutName: 'コミュニティサポート系トップ画面',
          Device: 1,
          ServiceType: 1,
          Direction: 1,
          Status: 1
        }
      ]
    }
  }
}